// Reads the current appregion cookie value, returns null if not set.
export const getAppRegionCookie = (): string | null => {
  const match = document.cookie
    .split(';')
    .map((c) => c.trim())
    .find((c) => c.startsWith('appregion='));
  return match ? decodeURIComponent(match.split('=')[1]) : null;
};
